import React from "react";
import { Box, Typography } from "@mui/material";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";

interface TrendIndicatorProps {
  value: number;
}

export const TrendIndicator: React.FC<TrendIndicatorProps> = ({ value }) => {
  let color = "text.secondary";
  let icon: React.ReactNode = null;

  if (value > 0) {
    color = "success.main";
    icon = <TrendingUpOutlinedIcon sx={{ fontSize: 16, ml: 0.5 }} />;
  } else if (value < 0) {
    color = "error.main";
    icon = <TrendingDownOutlinedIcon sx={{ fontSize: 16, ml: 0.5 }} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        color,
        fontFamily: "Roboto, sans-serif",
      }}
    >
      <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
        {value}
      </Typography>
      {icon}
    </Box>
  );
};